import controller from './google-sso-button-controller';
import template from './google-sso-button.html';

const GoogleSSOComponent = {
    controller,
    template,
};

export default GoogleSSOComponent;



// WEBPACK FOOTER //
// ./app/components/google-sso-button/google-sso-button-component.js